import { request } from "../utils/request.js"

export const userPersonalConfig_findForCurrentUser = (args) => request({
    url: 'userPersonalConfig/findForCurrentUser',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const userPersonalConfig_updateValue = (pojo, args) => request({
    url: 'userPersonalConfig/updateValue',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/userPersonalConfig.js